// extracted by mini-css-extract-plugin
export default {"gameGrid":"Minefield_gameGrid__DkdOo","minefieldRow":"Minefield_minefieldRow__c4mIe"};